// 获取当前页码
import _get from 'lodash/get';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { enumerateGroupItems } from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';

const getSlideIndex = (slideModel) => {
    if (!slideModel) return 0;
    const slideIndex = slideModel?.presentationRef?.indexOfSlide(slideModel);
    const { firstSlideNum = 1 } = slideModel.presentationRef || {};
    if (slideIndex === -1) {
        return 0;
    }
    return slideIndex + firstSlideNum - 1 || 0;
};
// 更新slideModel上挂载的slideIndex，子元素中存在编号时更新TextBody
// 20221104 踩坑。shapeModelObserver 监听 slideIndex 触发mobx更新组件，但组件内部判断更新方式是 editorShouldUpdate
const setSlideIndex = (uiData) => {
    uiData?.children.forEach((slideModel) => {
        slideModel?.children.forEach((element) => {
            if (_get(element, 'type') === UIModelType.GROUP) {
                // 若为组合元素，遍历组合下的所有子元素
                enumerateGroupItems(element, (shapeModel) => {
                    if (shapeModel?.hasSlideNumber?.()) {
                        shapeModel.state.dataChanged = true;
                        shapeModel.updateState.editorShouldUpdate = true;
                    }
                }, [UIModelType.GROUP, UIModelType.IMAGE, UIModelType.TABLE, UIModelType.CONNECTOR]);
            } else {
                if (element?.hasSlideNumber?.()) {
                    element.state.dataChanged = true;
                    element.updateState.editorShouldUpdate = true;
                }
            }
        });
        // 更新slideModel挂载的slideIndex
        slideModel.slideIndex = slideModel.presentationRef.indexOfSlide(slideModel);
    });
};
export { setSlideIndex };
export { getSlideIndex };
